import React from 'react'
import { Outlet } from 'react-router-dom'

function ProcessSection() {
  return (
    <div className='section-process-content'> 
    <Outlet/>
    </div>
  )   
}

export default ProcessSection